import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { truncateText, visuallyHidden } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledButtonText = styled.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isHidden'].includes(prop);
  }
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  color: inherit;\n  display: inline-block;\n  pointer-events: none;\n  z-index: ", ";\n\n  ", "\n"])), truncateText, function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex.buttonContent.value;
}, function (_ref2) {
  var isHidden = _ref2.isHidden;
  return isHidden && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n\n      && {\n        position: absolute;\n      }\n    "])), visuallyHidden);
});

var ButtonText = function ButtonText(props) {
  return /*#__PURE__*/_jsx(StyledButtonText, _objectSpread({}, props));
};

ButtonText.displayName = "ButtonText";
ButtonText.propTypes = {
  /** If true, visually hides text */
  isHidden: PropTypes.bool
};
ButtonText.defaultProps = {
  isHidden: false
};
export { ButtonText };